import React from "react"
import { Round, TeamRound } from "../types"

interface ConfirmCourseScreenProps {
  round: Round
  teamRound: TeamRound
  confirmCourse()
  showHelp()
}

export default function ConfirmCourseScreen({ round, teamRound, confirmCourse, showHelp }: ConfirmCourseScreenProps) {
  return (
    <>
      <div className="screen-heading" style={{ textAlign: "left" }}>
        <h1 className="screen-title">Confirm Course</h1>
      </div>
      <div className="screen-body" style={{ borderTop: "1px solid #CCC", paddingTop: "1rem", textAlign: "left" }}>
        <p>
          You should be playing <CourseName round={round} teamRound={teamRound} />. If course staff or someone else is
          directing you differently, please contact Spark Help. All league players need to play the same 9 holes. Scores
          from holes other than <CourseName round={round} teamRound={teamRound} /> will not count towards the round's
          results.
        </p>

        <div style={{ width: "100%", marginTop: "2rem", textAlign: "center" }}>
          <a className="action-button" style={{ width: "100%", maxWidth: "22rem" }} onClick={confirmCourse}>
            Continue
          </a>
        </div>

        <div style={{ width: "100%", marginTop: "2rem", textAlign: "center" }}>
          <a style={{ fontSize: 14, textDecoration: "underline" }} onClick={showHelp}>
            Contact Spark Help
          </a>
        </div>
      </div>
    </>
  )
}

interface CourseNameProps {
  round: Round
  teamRound: TeamRound
}

function CourseName({ round, teamRound }: CourseNameProps) {
  if (round.league.multipleCourses && round.holes.length > 9) {
    return (
      <>
        the <strong>{teamRound.startHoleNumber > 9 ? "back" : "front"} 9</strong> of the{" "}
        <strong>{round.course.shortLabel}</strong> course
      </>
    )
  }

  if (round.league.multipleCourses) {
    return (
      <>
        the <strong>{round.course.shortLabel}</strong> course
      </>
    )
  }

  return (
    <>
      the <strong>{teamRound.startHoleNumber > 9 ? "back" : "front"} 9</strong>
    </>
  )
}
